import { Table as ChakraTable } from '@chakra-ui/react';
import { forwardRef } from 'react';

const TableColumnHeader = forwardRef<
  HTMLTableCellElement,
  ChakraTable.ColumnHeaderProps
>((props, ref) => (
  <ChakraTable.ColumnHeader
    ref={ref}
    borderBottomWidth={0}
    fontWeight="semibold"
    px={1}
    pt={1}
    pb={3}
    {...props}
  />
));

type TableRootProps = Omit<ChakraTable.RootProps, 'size' | 'variant'>;

const TableRoot = forwardRef<HTMLTableElement, TableRootProps>((props, ref) => (
  <ChakraTable.Root ref={ref} size="sm" {...props} />
));

const TableCell = forwardRef<HTMLTableCellElement, ChakraTable.CellProps>(
  (props, ref) => (
    <ChakraTable.Cell ref={ref} borderBottomWidth={0} p={1} {...props} />
  )
);

const TableRow = forwardRef<HTMLTableRowElement, ChakraTable.RowProps>(
  (props, ref) => (
    <ChakraTable.Row background="transparent" ref={ref} {...props} />
  )
);

const Table = {
  Root: TableRoot,
  Header: ChakraTable.Header,
  ColumnHeader: TableColumnHeader,
  Body: ChakraTable.Body,
  Row: TableRow,
  Cell: TableCell,
};

export default Table;
